module.exports = __webpack_public_path__ + "img/28.d82552f1.jpg";